import { createFileRoute, redirect } from '@tanstack/react-router'
import { ConsoleLayout } from '../../features/platform/console-layout'
import { PLATFORM_DISABLED } from '../../features/platform/login-page'
import { ConsoleNotFound, ConsoleRouteError } from '../../features/platform/route-states'
import { platformSessionQueryOptions } from '../../features/platform/session'
import { isApiError } from '../../lib/api'

/**
 * The super-admin console, behind its own sign-in. No console session (or no console on this
 * server) → /platform/login, remembering where the operator was going.
 */
export const Route = createFileRoute('/platform/_console')({
  beforeLoad: async ({ context, location }) => {
    try {
      const platformSession = await context.queryClient.ensureQueryData(platformSessionQueryOptions)
      return { platformSession }
    } catch (error) {
      if (isApiError(error) && (error.status === 401 || error.code === PLATFORM_DISABLED)) {
        throw redirect({ to: '/platform/login', search: { redirect: location.href }, replace: true })
      }
      throw error
    }
  },
  component: ConsoleLayout,
  errorComponent: ConsoleRouteError,
  notFoundComponent: ConsoleNotFound,
})
